export enum MaintenanceHoursStatus {
  FINISHED = 1,
  UPCOMING = 3,
  ONGOING = 5
}
